import { GET_REWARD_POINTS } from '@/types/getters';
import { SET_REWARD_POINTS } from '@/types/mutations';
import { FETCH_REWARD_POINTS } from '@/types/actions';
import { defineStore } from 'pinia';

import getRewardPoints from './getRewardPoints';

export const useLoyalty = defineStore('loyalty', {
  state: () => ({
    rewardPoints: {},
  }),
  getters: {
    [GET_REWARD_POINTS](state) {
      return state.rewardPoints;
    },
  },
  actions: {
    [SET_REWARD_POINTS](payload) {
      this.rewardPoints = payload;
    },
    async [FETCH_REWARD_POINTS]() {
      const rewardPointsData = await getRewardPoints();
      this[SET_REWARD_POINTS](rewardPointsData);
    },
  },
});
